import styled from 'styled-components';
import Img from '@pagerland/common/src/components/Img';

export const StyledImg = styled(Img)`
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(31, 24, 14, 0.08);
`;
